import React from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const pricingModelEnum = {
  liveRate: 'live-rate',
  free: 'free',
  flatRate: 'flat-rate',
  localDeliveryRate: 'local-delivery',
  pudo: 'pick-up-rate',
};

export const pricingModels = [
  {
    id: 'pick-up-rate',
    displayName: <FormattedMessage {...messages.pudo} />,
    description: <FormattedMessage {...messages.pudoDescription} />,
  },
  {
    id: 'local-delivery',
    displayName: <FormattedMessage {...messages.localDeliveryRate} />,
    description: <FormattedMessage {...messages.localDeliveryRateDescription} />,
  },
  {
    id: 'live-rate',
    displayName: <FormattedMessage {...messages.liveRate} />,
    description: <FormattedMessage {...messages.liveRateDescription} />,
  },
  {
    id: 'flat-rate',
    displayName: <FormattedMessage {...messages.flatRate} />,
    description: <FormattedMessage {...messages.flatRateTypeDescription} />,
  },
  {
    id: 'free',
    displayName: <FormattedMessage {...messages.freeMethod} />,
    description: <FormattedMessage {...messages.freeMethodDescription} />,
  },
];

export const fulfillmentPricingModels = [
  {
    id: 'live-rate',
    displayName: <FormattedMessage {...messages.calculatedRate} />,
    description: <FormattedMessage {...messages.calculatedRateDescription} />,
  },
  {
    id: 'flat-rate',
    displayName: <FormattedMessage {...messages.flatRate} />,
    description: <FormattedMessage {...messages.fulfillmentFlatRateTypeDescription} />,
  },
  {
    id: 'free',
    displayName: <FormattedMessage {...messages.noChargeRate} />,
    description: <FormattedMessage {...messages.noChargeRateDescription} />,
  },
];

export const additionalFeesEnum = {
  none: 'none',
  add: 'add',
  subtract: 'subtract',
};

export const fallbackOptionModeEnum = {
  dontShow: 'dont-show',
  flatRate: 'flat-rate',
  cartPercentage: 'cart-percentage',
};

export const fallbackOptions = [
  {
    id: 'dont-show',
    displayName: <FormattedMessage {...messages.doNotDisplay} />,
  },
  {
    id: 'flat-rate',
    displayName: <FormattedMessage {...messages.chargeFlatRate} />,
  },
  {
    id: 'cart-percentage',
    displayName: <FormattedMessage {...messages.chargePercentageOfCart} />,
  },
];

export const addedFeesModes = [
  {
    id: 'setAmount',
    displayName: <FormattedMessage {...messages.setAmountValue} />,
  },
  {
    id: 'percentageOfCarrierRate',
    displayName: <FormattedMessage {...messages.percentageOfCarrierRateValue} />,
  },
];

export const fulfillmentServiceNamesEnum = {
  requestedShippingMethod: 'Requested Shipping Method',
};
